<template>
    <div 
        class="o-p-qr-widget"
        :style="componentStyles"
    >

        <div class="o-p-qr-widget__header">
            {{$t(componentParams.header, 'Skanna QR-koden för att få kartan på din mobil')}}
        </div>
        <div class="o-p-qr-widget__code-wrapper">
            <QRCodeGenerator/>
        </div>
        <div class="o-p-qr-widget__info">
            <!-- <div class="o-p-qr-widget__info-title">
                {{$t(componentParams.title)}}
            </div>
            <div class="o-p-qr-widget__info-description">
                {{$t(componentParams.subtitle)}}
            </div> -->
            <!-- <div class="o-p-qr-widget__info-here">
                <div class="o-p-qr-widget__info-here-inside">
                    <div class="o-p-qr-widget__info-here-inside-du">
                        {{$t(componentParams.du)}}
                    </div>
                    <div class="o-p-qr-widget__info-here-inside-har">
                        {{$t(componentParams.har)}}
                    </div>
                </div>
            </div> -->
            <div class="o-p-qr-widget__info-logo">
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import QRCodeGenerator from '../o-qr-code-generator/o-qr-code-generator'

export default {
    name: 'OPQrWidget',
    components: {
        QRCodeGenerator
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters(['getMapConfigProp']),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPQrWidget.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPQrWidget.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPQrWidget.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OPQrWidget.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        }
    },
}
</script>

<style lang="scss">
@import "o-p-qr-widget";
</style>